import { Inject, Injectable } from '@angular/core';

import { WindowService } from '../shared/services/window.service';
import { SERVICE_WORKER_API_AVAILABLE } from './service-worker-api-available.injection-token';

@Injectable({
    providedIn: 'root'
})
export class ServiceWorkerMessageService {

    constructor(
        private readonly windowService: WindowService,
        @Inject(SERVICE_WORKER_API_AVAILABLE) private readonly serviceWorkerApiAvailable: boolean
    ) {
    }

    // Use this method to send a message to Service Worker where exactly one response is expected
    public async sendTransactionalMessage<T>(message: T, serviceWorker?: ServiceWorker): Promise<MessageEvent> {
        if (!this.serviceWorkerApiAvailable || typeof(MessageChannel) === 'undefined') {
            return;
        }

        serviceWorker = serviceWorker || await this.getServiceWorker();

        if (serviceWorker) {
            return new Promise<MessageEvent>(resolve => {
                const messageChannel = new MessageChannel();
                messageChannel.port1.onmessage = messageEvent => {
                    resolve(messageEvent);
                    // Close all ports so they can be GC-ed
                    messageChannel.port1.close();
                    messageChannel.port2.close();
                };
                serviceWorker.postMessage(message, [messageChannel.port2]);
            });
        }
    }

    // Use this method to send a message to Service Worker if response is not expected
    public async sendUnidirectionMessage<T>(message: T, serviceWorker?: ServiceWorker) {
        if (!this.serviceWorkerApiAvailable) {
            return;
        }

        serviceWorker = serviceWorker || await this.getServiceWorker();

        if (serviceWorker) {
            serviceWorker.postMessage(message);
        }
    }

    private async getServiceWorker() {
        try {
            const serviceWorkerContainer = this.windowService.nativeWindow.navigator.serviceWorker;
            const registration = await serviceWorkerContainer.ready;
            return registration.active;
        } catch {
            // Firefox throws error when user has 'Keep cookies until exit' and blocks service worker
            return null;
        }
    }
}
